import React, {ChangeEventHandler, HTMLProps, ReactElement} from 'react';

import {
    Form as FormikForm,
    FormikFormProps,
    Field as FormikField,
    ErrorMessage as FormikErrorMessage, useField,
} from 'formik';
import {FieldAttributes} from "formik/dist/Field";
import {ErrorMessageProps} from "formik/dist/ErrorMessage";

import '../index.css';


export const Form = (props: FormikFormProps) => (
    <FormikForm {...props} className={"flex flex-col gap-y-4 p-1"}>{props.children}</FormikForm>
)

export interface FieldLabelProps extends HTMLProps<HTMLLabelElement> {
    hasError?: boolean;
    optional?: boolean;
}
export const FieldLabel = (props: FieldLabelProps) => {

    const { optional, hasError, ...fieldLabelProps } = props;

    return (
        <label
            {...fieldLabelProps}
            className={`${hasError ? "text-red" : "text-grey--400"} flex items-center gap-x-2 font-medium font-roboto min-w-0 w-full`}
        >
            <span>
                {props.children}
                {props.optional &&
                    <span className={`${hasError ? "text-red" : "text-grey--400"} font-light text-sm font-roboto`}>&nbsp;·&nbsp;Facultatif</span>
                }
            </span>
        </label>
    )
}

export interface FieldEltProps extends FieldAttributes<any> {
    hasError?: boolean;
}
export const FieldElt = (props: FieldEltProps) => {
    const {hasError, ...fieldEltProps} = props;
    return (
        <FormikField
            {...fieldEltProps}
            className={
                `${hasError ? "border-red" : "border-grey--200"} ` +
                `p-2 rounded-md border min-w-0 w-full ` +
                `focus:!outline-2 focus:!outline-blue`
            }
        >{props.children}</FormikField>
    )
}

export const ErrorMessage = (props: ErrorMessageProps) => (
    <div className={"text-red text-sm"}>
        <FormikErrorMessage {...props} />
    </div>
)

export interface FieldProps extends FieldAttributes<any> {
    label?: string,
    optional?: boolean,
    explication?: string,
}

export const Field = (props: FieldProps): ReactElement => {
    const {label, optional, explication, ...fieldEltProps} = props;
    // @ts-ignore
    const [field, meta] = useField(fieldEltProps);
    return (
      <div
        className={`${
          props.className || ""
        } flex flex-col gap-y-1 flex-1 min-w-40 select:bg`}
      >
        {!!label && (
          <FieldLabel
            htmlFor={props.id}
            optional={optional}
            hasError={meta.touched && !!meta.error}
          >
            {label}
          </FieldLabel>
        )}
        {props.type === "radioYN" ? (
          <div
            role="group"
            aria-labelledby={`${fieldEltProps.name}Group`}
            className={"flex gap-x-4"}
          >
            <label className={"flex gap-x-1 cursor-pointer"}>
              <FieldElt
                  type="radio"
                  name={fieldEltProps.name}
                  value={"true"}
                  onChange={(e: ChangeEventHandler) => {
                      field.onChange(e);
                      !!props.onChange && props.onChange(e);
                  }}
                  className={"items-center"}
              />
              <span className={"font-roboto text-black"}>Oui</span>
            </label>
            <label className={"flex gap-x-1 cursor-pointer"}>
              <FieldElt
                type="radio"
                name={fieldEltProps.name}
                value={"false"}
                onChange={(e: ChangeEventHandler) => {
                    field.onChange(e);
                    !!props.onChange && props.onChange(e);
                }}
                className={"items-center"}
              />
              <span className={"font-roboto text-black"}>Non</span>
            </label>
          </div>
        ) : (
          <FieldElt
            {...fieldEltProps}
            hasError={meta.touched && !!meta.error}
            onChange={(e: ChangeEventHandler) => {
              field.onChange(e);
              !!props.onChange && props.onChange(e);
            }}
          >
            {props.children}
          </FieldElt>
        )}
        {explication && (
          <div className={"text-sm text-grey--400"}>{explication}</div>
        )}
        <ErrorMessage name={props.name} />
      </div>
    );
}

export const FormRow = (props: HTMLProps<HTMLDivElement>) => (
    <div className={"flex gap-x-4 gap-y-2 w-full flex-wrap"}>
        {props.children}
    </div>
)